/**
 * @generated SignedSource<<8c7a81ecb9747f85dd5aba188d4b907f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationQuinyxCreateScreenMutation$variables = {
  apiKey: string;
};
export type IntegrationQuinyxCreateScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationQuinyx: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationQuinyxCreateScreenMutation = {
  response: IntegrationQuinyxCreateScreenMutation$data;
  variables: IntegrationQuinyxCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "apiKey"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "apiKey",
            "variableName": "apiKey"
          }
        ],
        "concreteType": "IntegrationQuinyx",
        "kind": "LinkedField",
        "name": "activateIntegrationQuinyx",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationQuinyxCreateScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationQuinyxCreateScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "93e6c7a920259bee175e84bd105aa841",
    "id": null,
    "metadata": {},
    "name": "IntegrationQuinyxCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationQuinyxCreateScreenMutation(\n  $apiKey: String!\n) {\n  store {\n    activateIntegrationQuinyx(apiKey: $apiKey) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8e0990c49bd75ff68691cfd3c767953";

export default node;
